import { HelpMessage } from 'utils/constants'
import CIMSFormItem from 'components/CIMSFormItem'
import CIMSSelect from 'components/CIMSSelect'
import { CIMSSelectProps } from 'components/CIMSSelect/types'

const GroupSelect: React.FC<Pick<CIMSSelectProps, 'options' | 'loading'>> = ({
  loading,
  options,
}) => {
  return (
    <CIMSFormItem label="Group" name="group" help={HelpMessage.PayItems.Groups}>
      <CIMSSelect loading={loading} options={options} />
    </CIMSFormItem>
  )
}

export default GroupSelect
